import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function AutopaymentIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_18704_3040)">
          <path
            d="M16.0135 9.8912V16.0003L20.8832 19.0548M22.8311 12.9457H27.7008M27.7008 12.9457V7.85484M27.7008 12.9457C26.2058 11.0277 25.0224 9.5972 23.5895 8.08011C22.1006 6.52357 20.2059 5.46024 18.1422 5.02298C16.0785 4.58573 13.9373 4.79393 11.9861 5.62159C10.0349 6.44925 8.36033 7.85965 7.17153 9.67657C5.98272 11.4935 5.33243 13.6364 5.30191 15.8375C5.27138 18.0385 5.86198 20.2002 6.9999 22.0524C8.13783 23.9046 9.77262 25.3651 11.7 26.2516C13.6274 27.138 15.7619 27.411 17.8369 27.0365C19.9119 26.662 21.8353 25.6565 23.3667 24.1457"
            stroke="#01425F"
            strokeWidth="2.475"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_18704_3040">
            <rect
              width="32"
              height="32"
              fill="white"
              transform="translate(0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  )
}
